/**
 * @namespace helpers
 */

/**
 * Helper functions for Arrays
 *
 * @module array
 * @memberof helpers
 * @see helpers
 */

import { getId } from './entity'

/**
 * Flatten any n-dimensional array
 *
 * @function
 * @param  {Array} arr
 * @return {Array} flat array
 */
export const flatten = (arr) =>
  arr.reduce(
    (flat, next) =>
      flat.concat(
        Array.isArray(next)
          ? flatten(next)
          : next
      ),
    []
  )

/**
 * Changes array of objects to map
 * Use in .reduce like .reduce(toMap(getId), {})
 *
 * @function
 * @param  {Function} key - getter for key value
 * @param  {String} obj - object-accumulator
 * @param  {Object} val - array item
 * @return {Object}
 */
export const toMap = (key = getId) => (obj, val) => {
  obj[key(val)] = val
  return obj
}

/**
 * Filter unique elements
 * Function to use in [].filter method to leave only unique elements
 *
 * @function
 * @param  {any} value - value from array
 * @param  {Number} i - value index within array
 * @param  {any[]} arr - array
 * @return {Boolean}
 */
export const leaveUnique = (value, i, arr) =>
  value && arr.indexOf(value) === i
